import BlockContent, { NodeRendererProps } from "@sanity/block-content-to-react";
import React from "react";
import { ElementClasses } from "./PortableText";

interface Props {
    sanityProps: React.PropsWithChildren<NodeRendererProps>;
    customElementClasses?: ElementClasses;
}

const ListRenderer = ({sanityProps, customElementClasses}: Props) => {
    switch (sanityProps.type) {
        case "bullet":
            return (
                <ul className={customElementClasses?.ul ?? ""}>
                    {sanityProps.children}
                </ul>);
    }

    // Fall back to default handling
    return BlockContent.defaultSerializers.list?.(sanityProps) ?? null;
};

export default ListRenderer;